import { z } from 'zod'

export const BloodType = z.enum([
  'A',
  'B',
  'AB',
  'O',
  'A_NEGATIVE',
  'B_NEGATIVE',
  'AB_NEGATIVE',
  'O_NEGATIVE'
])
